import type { TemplateStudioLibraryImage } from "@shared/schema";
import type { TopPerformerMetric } from "@shared/creative-performance";

export type LibraryImage = Omit<TemplateStudioLibraryImage, "enabled"> & {
  enabled?: boolean;
  url: string;
  previewUrl: string;
  source?: "upload" | "performance" | "saved-ad";
  externalAdId?: string | null;
  performanceSnapshot?: {
    metric: TopPerformerMetric;
    value: number;
    spend: number;
    costPer: number | null;
    since: string;
    until: string;
  } | null;
};

export type PerformanceConfig = { enabled: boolean; resolvedLeadEventName?: string | null };
export type TypeSuggestion = { typeId: string; reason: string; confidence: "high" | "medium" | "low" };
export type SuggestionState = { loading?: boolean; error?: string; suggestions?: TypeSuggestion[] };
export type ImportStatus = { state: "pending" | "success" | "error"; error?: string };
export type TopPerformerWindow = 7 | 30 | 90;

export function dateRangeForWindow(days: TopPerformerWindow) {
  const until = new Date().toISOString().slice(0, 10);
  const start = new Date(`${until}T00:00:00.000Z`);
  start.setUTCDate(start.getUTCDate() - days + 1);
  return { since: start.toISOString().slice(0, 10), until };
}

export function metricLabel(metric: TopPerformerMetric) {
  return metric === "leads" ? "leads" : metric === "checkouts" ? "checkouts" : "purchases";
}